/**
 * onboarding.js — thin API client for the onboarding-tour flags.
 * See routes/onboarding.py (PATCH /api/onboarding/seen).
 */
import { authApi } from "./auth";

/**
 * Record that the current user has completed/dismissed a surface's
 * onboarding at the given content version. Returns the full updated
 * `onboarding_seen` map ({ surface: version, ... }).
 */
export const markOnboardingSeen = async (surface, version) => {
  const { data } = await authApi.patch("/onboarding/seen", { surface, version });
  return data?.onboarding_seen || {};
};

/**
 * Record a First Run generation bail-out (240s client timeout or a surfaced
 * generation error) so we can measure the real failure rate. Best-effort —
 * never throws to the caller.
 */
export const logFirstRunBailout = async (payload) => {
  try {
    await authApi.post("/onboarding/first-run-bailout", payload);
  } catch {
    /* telemetry only — ignore */
  }
};
